import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import camelCase from "lodash/camelCase";
import AssetItemLabel from "./AssetItemLabel";
import { getCustomDescriptionValue } from "../../../utils/asset";

const isValidSerialNumber = value => value && value.toLowerCase() !== "n/a";

const getItemIdDisplay = asset => {
  const serialNumber = asset?.serialNumber || asset?.serial_number;
  const barcode = asset?.barcode;

  if (isValidSerialNumber(serialNumber)) {
    return `${asset.itemId}, S/N: ${serialNumber}`;
  }

  if (barcode) {
    return `${asset.itemId}, ${barcode}`;
  }

  return asset.itemId;
};

const getDisplayDescription = asset => {
  if (asset?.description) return asset.description;

  const customDescription = getCustomDescriptionValue(asset);
  if (customDescription) return customDescription;

  const fallbackFields = [
    asset?.manufacturer,
    asset?.descriptionComments,
    asset?.model
  ].filter(Boolean);

  return fallbackFields.join(", ");
};

export default function AssetItemDescription({
  displayItemId = true,
  asset,
  order,
  descriptionLines = 1,
  labelSuffix,
}) {
  const selectedField = order ? camelCase(order.split(".")[0]) : undefined;
  const itemIdDisplay = getItemIdDisplay(asset);
  const displayDescription = getDisplayDescription(asset);
  const topLabel = selectedField ? (
    <AssetItemLabel asset={asset} selectedField={selectedField} suffix={labelSuffix} />
  ) : null;

  return (
    <Box ml="22px" overflow="hidden" display="flex" flexDirection="column" flexGrow={1}>
      {topLabel}
      {selectedField !== "itemId" && displayItemId && (
        <Typography variant="body1" lineHeight={1.25} color="textSecondary" fontWeight={500}>
          {itemIdDisplay}
        </Typography>
      )}
      <Box width="100%" maxWidth="100%">
        <Typography
          sx={{
            width: "100%",
            maxWidth: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: descriptionLines > 1 ? "normal" : "nowrap",
            wordBreak: "break-word",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: descriptionLines,
          }}
          color="textSecondary"
          lineHeight={1.25}
          component="div"
          variant="body1"
        >
          {displayDescription}
        </Typography>
      </Box>
    </Box>
  );
}
